import {useEffect, useMemo, useState} from 'react';

import {OpenDirection, Position, SubMenuPosition} from './types';

/**
 * Hook to calculate submenu position based on viewport and direction
 */
export const useSubMenuPosition = (
  position: Position,
  direction: OpenDirection
): SubMenuPosition => {
  const [viewportWidth, setViewportWidth] = useState(window.innerWidth);
  const [viewportHeight, setViewportHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setViewportWidth(window.innerWidth);
      setViewportHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return useMemo(() => {
    // Calculate if dropdown is above or below 50% of the viewport
    const dropdownMidpoint = (position.top + position.bottom) / 2;
    const viewportMidpoint = viewportHeight / 2;
    const shouldOpenDown = dropdownMidpoint < viewportMidpoint;

    if (direction.horizontal === 'right') {
      if (shouldOpenDown) {
        return {
          left: position.right + 1,
          top: position.top,
        };
      } else {
        return {
          left: position.right + 1,
          bottom: viewportHeight - position.bottom + 4,
        };
      }
    } else if (direction.horizontal === 'left') {
      if (shouldOpenDown) {
        return {
          right: viewportWidth - position.left + 1,
          top: position.top,
        };
      } else {
        return {
          right: viewportWidth - position.left + 1,
          bottom: viewportHeight - position.bottom - 4,
        };
      }
    }
    return {};
  }, [direction, position, viewportWidth, viewportHeight]);
};
